import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import templateService from "../../services/templateService";

const useTemplates = ({
  pageNum,
  pageSize,
  sectorId,
  subjectId,
  moduleArea,
  accountId,
  siteExternalIds,
  frequency,
  filterText,
  orderByColumn,
  sortOrder,
}) =>
  useQuery(
    [
      queryKeys.templates,
      moduleArea,
      pageSize,
      pageNum,
      sectorId,
      subjectId,
      moduleArea,
      accountId,
      siteExternalIds?.join(","),
      frequency,
      filterText,
      orderByColumn,
      sortOrder,
    ],
    () =>
      templateService.fetchTemplates({
        pageNum,
        pageSize,
        sectorId,
        subjectId,
        moduleArea,
        accountId,
        siteExternalIds,
        frequency,
        filterText,
        orderByColumn,
        sortOrder,
      }),
    {
      enabled: siteExternalIds?.length > 0,
    }
  );

export default useTemplates;
